export const SET_EMAIL = 'SET_CONVERT_EMAIL';
export const SET_SUCCESS = 'SET_CONVERT_SUCCESS';
export const RESET = 'RESET_CONVERT';
export const SET_TYPES = 'SET_CONVERT_TYPES';



// WEBPACK FOOTER //
// ./src/views/ConvertLeads/flow/actionTypes.js